import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

// TODO: Whitelist for internationalization
export const retailerFundedMarketingHomeAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.RetailerFundedMarketingRetailerFundedMarketingViewAccess,
      Permission.RetailerFundedMarketingRetailerFundedMarketingInsights,
    ],
    restrictedBannersAllowed: true,
    notFeatureToggles: [FeatureToggle.retailerFundedMarketingUserDenyList],
  },
]
